import type {Result} from './Result';

export const Ok = <T>(data: T): Result<T, never> => {
  return {ok: true, value: data};
};
